import { focusCalendarSurface } from '../actions/focusCalendarSurface';
import { preventFocusDuringCurrentRender } from 'owa-calendar-focus-manager';
import { exitSearch, SearchScenarioId } from 'owa-search';
import { orchestrator } from 'satcheljs';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// This orchestrator needs to focus surface or canvas, depending on current view type

orchestrator(exitSearch, actionMessage => {
    // when exiting calendar search session via Escape hotkey, set focus back to surface root
    if (
        actionMessage.scenarioId === SearchScenarioId.Calendar &&
        (actionMessage.actionSource === 'Escape' ||
            actionMessage.actionSource === 'QuickAddCalendarFromSuggestion')
    ) {
        preventFocusDuringCurrentRender();
        setTimeout(focusCalendarSurface, 0);
    }
});
